"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const MapSideBarPanel_vue_1 = __importDefault(require("./MapSideBarPanel.vue"));
const NeedMapsItem_vue_1 = __importDefault(require("./NeedMaps/NeedMapsItem.vue"));
const RateCertificateItem_vue_1 = __importDefault(require("./NeedMaps/RateCertificateItem.vue"));
const AIGenItem_vue_1 = __importDefault(require("./NeedMaps/AIGenItem.vue"));
const project_1 = require("@becrop/components/Results/Abstract/Interfaces/project");
const NeedMap_1 = require("@becrop/abstract/Models/NeedMap");
const FieldsRecommendations_vue_1 = __importDefault(require("./Recommendations/components/FieldsRecommendations.vue"));
const BreakdownOfFields_vue_1 = __importDefault(require("./Recommendations/components/BreakdownOfFields.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
const trans_1 = require("@common/tsutils/trans");
const UpgradeTeaser_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/UpgradeTeaser.vue"));
let MapSideBarPanelNeedMapsScaffold = class MapSideBarPanelNeedMapsScaffold extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.productSlugSelected = '';
        this.productSelected = null;
        this.panelRecommendations = false;
        this.forceDismiss = false;
        this.isToggled = false;
        this.eventTracker = new EventTracker_1.default();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    mounted() {
    }
    updateProductSelected(product) {
        this.productSlugSelected = product.slug;
        this.productSelected = product;
    }
    get fieldsBySelectProduct() {
        const fields = this.mainProjectDelivery.fields;
        const fieldsFilter = [];
        for (const field of fields) {
            for (const recommendation of field.recommendations) {
                if (recommendation.needMap === this.currentNeedMap.category.slug) {
                    for (const product of recommendation.products) {
                        if (product.slug.toUpperCase() === this.productSlugSelected.toUpperCase()) {
                            fieldsFilter.push(field);
                        }
                    }
                }
            }
        }
        /* return fields.filter((field: FieldRecommendation) => {
            return field.recommendations.some((recommendation: Recommendation) => {
                 return recommendation.products.some((product: product_I) => product.slug.toUpperCase() === this.productSlugSelected.toUpperCase())
            })
        }) */
        const sortedArray = fieldsFilter.sort((a, b) => {
            const nameA = a.name.toLowerCase(); // Convertir a minúsculas para comparación
            const nameB = b.name.toLowerCase();
            // Expresión regular para extraer las partes de texto y los números
            const regex = /(\D+)(\d*)/;
            const partsA = nameA.match(regex);
            const partsB = nameB.match(regex);
            if (partsA && partsB) {
                // Comparar las partes de texto
                const textComparison = partsA[1].localeCompare(partsB[1]);
                if (textComparison !== 0) {
                    return textComparison;
                }
                // Comparar los números, convirtiendo a número para la comparación
                const numA = parseInt(partsA[2], 10) || 0; // Convertir a número o 0 si no hay
                const numB = parseInt(partsB[2], 10) || 0;
                return numA - numB;
            }
            else {
                return nameA - nameB;
            }
        });
        return sortedArray;
    }
    updateFieldActiveKey(f) {
        this.$emit('updateFieldActiveKey', f);
    }
    emitFieldNamePreSelect(name) {
        this.$emit('fieldNamePreSelect', name);
    }
    get optionsRateExcluded() {
        const options = [
            {
                "slug": "bio-stimulant-needs",
                "title": (0, trans_1.trans)('need_mapping.categories.bio_stimulant_needs.title'),
                "caption": (0, trans_1.trans)('need_mapping.categories.bio_stimulant_needs.caption'),
                "description": (0, trans_1.trans)('need_mapping.categories.bio_stimulant_needs.description'),
                "enabled": false,
                "reverseScale": true,
                "typeScale": "score",
                "results": {}
            },
            {
                "slug": "crop-protection-needs",
                "title": (0, trans_1.trans)('need_mapping.categories.crop_protection_needs.title'),
                "caption": (0, trans_1.trans)('need_mapping.categories.crop_protection_needs.caption'),
                "description": (0, trans_1.trans)('need_mapping.categories.crop_protection_needs.description'),
                "enabled": false,
                "reverseScale": true,
                "typeScale": "score",
                "results": {}
            },
            {
                "slug": "management-needs",
                "title": (0, trans_1.trans)('need_mapping.categories.management_needs.title'),
                "caption": (0, trans_1.trans)('need_mapping.categories.management_needs.caption'),
                "description": (0, trans_1.trans)('need_mapping.categories.management_needs.description'),
                "enabled": false,
                "reverseScale": true,
                "typeScale": "score",
                "results": {}
            }
        ];
        return options.map((o) => new NeedMap_1.NeedMap(o));
    }
    dismissRecommendations() {
        this.forceDismiss = true;
    }
    toggleRecommendations(isToggled) {
        this.forceDismiss = false;
        this.isToggled = this.isToggled;
        this.panelRecommendations = true;
        this.$emit('onToggleRecommendations', isToggled);
    }
    eventTrackerNeedMapOption() {
        let optionSelected = '';
        if (this.currentNeedMap.category.slug === 'bio-stimulant-needs')
            optionSelected = 'Nutritional needs';
        if (this.currentNeedMap.category.slug === 'crop-protection-needs')
            optionSelected = 'Disease risk';
        if (this.currentNeedMap.category.slug === 'management-needs')
            optionSelected = 'Management Practices Improvement';
        const dataEvent = { option: optionSelected };
        this.eventTracker.trackEvent('needMapOption', dataEvent);
    }
    selectOption(slug) {
        if (this.currentNeedMap.category.slug != 'aigen') {
            const needMap = new NeedMap_1.NeedMap({ 'slug': slug });
            this.dismissRecommendations();
            this.$emit('updateNeedMap', needMap);
        }
    }
    get hasRetrievedRecommendation() {
        return (this.mainProjectDelivery.recommendationsFeedback.brief === 'retrieved') ? true : false;
    }
    hasRecommendation(needMap) {
        // TODO: Match recommendations with need maps
        return this.needMapRecommendation !== undefined && this.needMapRecommendation.products.length > 0;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new project_1.AreaProjectDeliverable({}) })
], MapSideBarPanelNeedMapsScaffold.prototype, "mainProjectDelivery", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new NeedMap_1.NeedMap({}) })
], MapSideBarPanelNeedMapsScaffold.prototype, "currentNeedMap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new project_1.AreaProjectBuilt({}) })
], MapSideBarPanelNeedMapsScaffold.prototype, "mainProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'single' })
], MapSideBarPanelNeedMapsScaffold.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBarPanelNeedMapsScaffold.prototype, "entityType", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBarPanelNeedMapsScaffold.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBarPanelNeedMapsScaffold.prototype, "setFieldNamePreSelect", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBarPanelNeedMapsScaffold.prototype, "fieldActiveKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], MapSideBarPanelNeedMapsScaffold.prototype, "currentFarm", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentNeedMap.category.slug')
], MapSideBarPanelNeedMapsScaffold.prototype, "eventTrackerNeedMapOption", null);
MapSideBarPanelNeedMapsScaffold = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapSideBarPanel: MapSideBarPanel_vue_1.default,
            NeedMapsItem: NeedMapsItem_vue_1.default,
            RateCertificateItem: RateCertificateItem_vue_1.default,
            AIGenItem: AIGenItem_vue_1.default,
            Loading: bmk_ui_framework_1.Loading,
            Ribbon: bmk_ui_framework_1.Ribbon,
            FieldsRecommendations: FieldsRecommendations_vue_1.default,
            BreakdownOfFields: BreakdownOfFields_vue_1.default,
            Button: bmk_ui_framework_1.Button,
            X: lucide_vue_next_1.X,
            UpgradeTeaser: UpgradeTeaser_vue_1.default
        },
    })
], MapSideBarPanelNeedMapsScaffold);
exports.default = MapSideBarPanelNeedMapsScaffold;
